import { Box, Grid, Typography } from '@mui/material';
import _ from 'lodash';
import { DateTime } from 'luxon';
import React from 'react';
import { humanizeDate } from '../../utility/dateUtils';
import {
  dateCellSx,
  datesHeaderContainerSx,
  datesHeaderGridSx,
  daysGridTemplate,
  employeeHeaderSx,
  eventHeaderSx,
} from './employeesScheduleStyles';

const DatesHeader: React.FC<{ weekStart: DateTime, dayCount: number }> = ({ weekStart, dayCount }) => (
  <>
    <Grid size={1} sx={employeeHeaderSx}>
      <Typography>Employees</Typography>
    </Grid>

    <Grid size={dayCount} sx={datesHeaderContainerSx}>
      <Box sx={eventHeaderSx}>
        <Typography fontWeight={500}>Events</Typography>
      </Box>

      <Box sx={{ ...datesHeaderGridSx, ...daysGridTemplate(dayCount) }}>
        {_.map(_.range(dayCount), (dayDiff) => {
          const date = weekStart.plus({ day: dayDiff });

          return (
            <Box key={dayDiff} sx={dateCellSx}>
              <Typography variant="caption" title={humanizeDate(date.toISO())}>
                {`${date.weekdayShort}, ${date.day}`}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Grid>
  </>
);

export default DatesHeader;
